import { Game } from "@/model/Game.model";
import { User } from "@/model/User.model";
import { ActionContext, ActionTree } from "vuex";
import { Mutations, MutationTypes } from "./mutations";
import { State } from "./state";
import GameService from "@/services/games.service";
import TemplateService from "@/services/challenge.service";
import { ChallengeSettings } from "@/model/ChallengeSettings.model";
import challengeService from "@/services/challenge.service";

export enum ActionTypes {
  SET_CURRENT_USER = "SET_CURRENT_USER",
  GET_LIST_GAMES = "GET_LIST_GAME",
  GET_CHALLENGES_SETTINGS = "GET_CHALLENGES_SETTINGS",
  REMOVE_CHALLENGE = "REMOVE_CHALLENGE"
}

//Action
type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, State>, "commit">;

//Action Interface
export interface Actions {
  [ActionTypes.SET_CURRENT_USER](
    { commit }: AugmentedActionContext,
    payload: User
  ): void;
  [ActionTypes.GET_LIST_GAMES]({ commit }: AugmentedActionContext): void;
  [ActionTypes.GET_CHALLENGES_SETTINGS]({
    commit
  }: AugmentedActionContext): void;
  [ActionTypes.REMOVE_CHALLENGE]({ commit }: AugmentedActionContext, payload: any): void;
}

export const actions: ActionTree<State, State> & Actions = {
  [ActionTypes.SET_CURRENT_USER]({ commit }, payload: User) {
    commit(MutationTypes.SET_CURRENT_USER, payload);
  },
  [ActionTypes.GET_LIST_GAMES]({ commit }) {
    GameService.getListGame().subscribe((result: Game[]) => {
      if (result) {
        commit(MutationTypes.SET_LIST_GAMES, result);
      }
    });
  },
  [ActionTypes.GET_CHALLENGES_SETTINGS]({ commit }) {
    TemplateService.getChallengesSettings().subscribe(
      (result: ChallengeSettings[]) => {
        if (result) {
          commit(MutationTypes.SET_CHALLENGES_SETTINGS, result);
        }
      }
    );
  },
  [ActionTypes.REMOVE_CHALLENGE]({ commit }, payload: any) {
    challengeService.removeChallenge(payload);
  }
};
